import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, X, ArrowRight } from "lucide-react";

const KEY = "tl_launch_banner_dismissed_v1";

export default function LaunchBanner() {
  const [open, setOpen] = useState(() => { try { return !localStorage.getItem(KEY); } catch { return true; } });
  if (!open) return null;
  const dismiss = () => { try { localStorage.setItem(KEY, "1"); } catch {} setOpen(false); };
  return (
    <div className="relative bg-[#0A0A0A] border-b border-[#FF6A00]/40" data-testid="launch-banner">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-3 pr-12 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <span className="inline-flex items-center gap-1.5 self-start px-2 py-0.5 bg-[#FF6A00] text-black text-[10px] font-black uppercase tracking-widest" data-testid="launch-banner-tag">
          <span className="w-1.5 h-1.5 bg-black rounded-full animate-pulse" /> Now launching
        </span>
        <p className="text-sm text-zinc-200 leading-snug" data-testid="launch-banner-text">
          <span className="font-bold text-white">We're live — Sydney first.</span> TradieLoop is kicking off with builders and tradies across greater Sydney before rolling out to the rest of Australia.
          <MapPin className="inline w-3.5 h-3.5 ml-1 -mt-0.5 text-[#FF6A00]" />
        </p>
        <Link to="/register" className="sm:ml-auto inline-flex items-center gap-1 self-start text-xs font-bold uppercase tracking-widest text-[#FF6A00] hover:text-white whitespace-nowrap" data-testid="launch-banner-cta">Join the launch <ArrowRight className="w-3.5 h-3.5" /></Link>
      </div>
      <button onClick={dismiss} aria-label="Dismiss" className="absolute right-3 top-3 p-1 text-zinc-500 hover:text-white" data-testid="launch-banner-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
